export enum Languages {
  English = 'en',
}
